function GeneralInfo() {
  const data = [
    {
      id: 1,
      title: "Name of the School",
      value: "Capitol Public School",
    },
    {
      id: 2,
      title: "Affiliation No. (If Applicable)",
      value: "830890",
    },
    {
      id: 3,
      title: "School Code (If Applicable)",
      value: "45810",
    },
    {
      id: 4,
      title: "Complete Address with PIN Code",
      value:
        "#2899, Pampapathi Rd, K.G Koppal, Saraswathipuram, Mysuru, Karnataka - 570009",
    },
    {
      id: 5,
      title: "Principal Name & Qualification",
      value: "Jagmeet Kaur, M.Phil, B.Ed",
    },
    {
      id: 6,
      title: "School Email ID",
      value: "capitolmysuru@gmail.com",
      isEmail: true,
    },
    {
      id: 7,
      title: "Contact Details",
      value: "9740903333 / 8970745451",
    },
  ];

  return (
    <section className="bg-gray-50 py-16 px-6">
      <div className="max-w-6xl mx-auto">

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-blue-900 mb-10 text-center">
          General Information
        </h2>

        {/* Table */}
        <div className="overflow-hidden rounded-2xl shadow-lg border">
          <table className="w-full text-left border-collapse">

            <thead className="bg-blue-900 text-white">
              <tr>
                <th className="px-6 py-4">Sl No</th>
                <th className="px-6 py-4">Information</th>
                <th className="px-6 py-4">Details</th>
              </tr>
            </thead>

            <tbody>
              {data.map((item, index) => (
                <tr
                  key={item.id}
                  className={`border-t ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-yellow-50 transition`}
                >
                  <td className="px-6 py-4 font-semibold text-blue-900">
                    {item.id}
                  </td>

                  <td className="px-6 py-4 font-medium text-gray-700">
                    {item.title}
                  </td>

                  <td className="px-6 py-4 text-gray-800">
                    {item.isEmail ? (
                      <a
                        href={`mailto:${item.value}`}
                        className="text-pink-600 font-semibold hover:underline"
                      >
                        {item.value}
                      </a>
                    ) : (
                      item.value
                    )}
                  </td>
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>
    </section>
  );
}

export default GeneralInfo;